export default "__VITE_ASSET__Cim0k89X__"